import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";

;
const icon2 = "https://winpeforum.com/assets/elements/DaivikRaval.png";
const icon3 = "https://winpeforum.com/assets/elements/PratitiDasgupta.png";
const icon4 = "https://winpeforum.com/assets/elements/AnkitaBalotia.png";
 
 

let duration = 400;

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
    this.Speaker2 = [
     
  
  
        {
          imgUrl: icon3,
          desc: `<div>
Pratiti is an infrastructure and private markets finance professional with experience spanning project finance, capital raising, and investment analysis across renewables, digital infrastructure, and private credit in India, Southeast Asia, and Europe. A Winpe Ambassador , she has been a part of the community since 2021 and is highly passionate about spearheading the cause of diversity in alternative investments.






 
          </div>`,
          name: "Pratiti Dasgupta ",
          post: `<div> 






          </div>`,
        },
  ];
    this.Speaker1 = [
       
        {
          imgUrl: icon4,
          desc: `<div>
Ankita Balotia is a Principal at Fireside Ventures, where she partners with founders building the next generation of consumer brands and platforms in India. Her select boards include Sweet Karam Coffee, Frubon, Ace Blend, Troovy, and Happi Planet.
<br/><br/>
Her work at Fireside focuses on helping companies move from strong product ideas to enduring consumer businesses. She works closely with founders on product strategy, customer insight, and scaling operating capabilities as companies transition from early traction to sustained growth. Ankita is particularly interested in how technology and data are reshaping consumer brands enabling companies to build deeper relationships with customers and evolve from product-led businesses into long-term consumer platforms.
<br/><Br/>
Before joining Fireside, Ankita was part of Venture Highway (now General Catalyst India), where she worked with early-stage startups across consumer and technology sectors.
<Br/><Br/>
Ankita spent over five years in management consulting with Bain & Company and Strategy, advising companies across consumer technology healthcare, and real estate on growth strategy and digital transformation.
<br/><Br/>
Ankita holds a degree in Computer Science from IIT Delhi and an MBA from IIM Ahmedabad. 




 
          </div>`,
          name: "Ankita Balotia ",
          post: `<div>Principal <br/>
Fireside Ventures






          </div>`,
        },
        {
          imgUrl: icon2,
          desc: `<div>
Daivik brings a well-rounded blend of investing, entrepreneurial, and capital markets experience, with over ten years across growth equity, investment banking, and business building. He has led and supported multiple equity transactions across diverse sectors, with a strong focus on India’s emerging new-age economy.
<br/><br/>
Prior to his current role, he was part of the growth equity investment team at Mirae Asset, and has also worked with Morgan Stanley and J.P. Morgan across capital markets and investment banking.
<br/><br/>
In addition to his investing experience, Daivik has hands-on operating exposure, having launched an online consumer business in the Middle East. He has successfully completed multiple growth equity investments in some of India’s leading new-tech companies (Swiggy, Bigbasket, Cashfree, Fibe etc.)

          </div>`,
          name: "Daivik Raval",
          post: `<div>Vice President, Growth Equity <br/>  Trifecta Capital 

          </div>`,
        },
       
    ];
 
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="Winpe Ignite: AI for Investors"
          image={"https://winpeforum.com/api/src/templates/emailers/assets/newsletter2022.png"}
          description="On 16th May 2026, Winpe hosted an Ignite session on how AI is reshaping investing workflows across sourcing, research, and diligence. Featuring Ankita Balotia and Daivik Raval, moderated by Pratiti Dasgupta, the session explored practical applications of AI in day-to-day investing workflows. Click here to view the recorded session.”
"
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left"> Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">Winpe Ignite: AI for Investors <br/> Practical AI Tools for Deal Sourcing, Research & Diligence </div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                  <span>May 16, 2026</span>
                  <br/>
                  <span> <i>Online</i></span>
                </div>
              </div>
              <br/>
 
 
              <div className="top_text" style={{textAlign: 'justify'}}> 
      On 16th May 2026, Winpe hosted an Ignite session on how AI is reshaping investing workflows across sourcing, research, and diligence. Featuring <a style={{color:'blue'}} href="https://www.linkedin.com/in/ankita-balotia1792/">Ankita Balotia</a> and <a  style={{color:'blue'}} href="https://www.linkedin.com/in/daivikraval/">Daivik Raval</a>, moderated by <a  style={{color:'blue'}}  href="https://www.linkedin.com/in/pratiti-dasgupta-bb92671b1/">Pratiti Dasgupta</a>, the session explored practical applications of AI in day-to-day investing workflows. Click <a  style={{color:'blue'}}  href="https://youtu.be/4vE_Yc7iAlQ">here</a> to view the recorded session.
<br/><br/>

A live poll kicked off the session, with the top challenge in the room being: “Trusting the output — I second-guess everything”. Both speakers addressed this directly, emphasising that investors should not wait for AI to become “perfect” before adopting it. 
<br/><br/>

 
  


<h4><b>Key Segments Discussed: </b></h4>
 
<p><b>AI in Deal Sourcing</b>- Tasks that once took hours of manual effort can now run end-to-end in the background.</p> 
<ul>
<li>Early Stage / Consumer: Instagram trend-tracking, Amazon & quick commerce scraping, and LinkedIn outreach can now be automated end-to-end — from spotting a category trend to reaching the founder building in it.
</li>
<li>Growth Stage: Relationships still drive growth-stage deal flow. AI strengthens them — mapping warm intro paths across the whole team’s network and flagging coverage gaps before opportunities go cold.</li>
</ul>

<p><b>Data & Knowledge System</b>- Strong data infrastructure and organised workflows are foundational for meaningful AI adoption. 
</p> 
<ul>
<li>Build a Knowledge Brain: A central repository of expert calls, meeting notes, and thesis evolution democratises institutional knowledge — giving every team member a partner’s depth of context in any conversation.
</li>
<li>Data Infrastructure First: A deal CRM is non-negotiable before any AI implementation. Centralise pitch decks, MIS, and founder notes in one place — tools like Granola can then auto-populate it from meeting notes, removing the manual burden entirely.</li>
</ul>
<br/> 
 <h4><b>Key Takeaways</b></h4>
 <ul>
    <li>AI adoption in investing is already happening across sourcing, research, and workflows.</li>
    <li>Relationship-building remains human, while technology strengthens efficiency and intelligence.</li>
    <li>Strong data infrastructure and knowledge systems are foundational for meaningful adoption.</li>
 </ul>



<br/> 
<h4><b>Tools & Platforms Mentioned</b></h4>
 <ul style={{columnCount:3, columnGap:'20px'}}>
<li>Happenstance</li>
<li>Harmonic AI</li>
<li>TagHash (Deal CRM)</li>
<li>LinkedIn Automation</li>
<li>Amazon & Quick Commerce Platforms</li>
<li>Instagram Trend Tracking</li>
 </ul>

<br/> 
 <p><b><i>AI is unlikely to replace investors, but investors who learn to work effectively with AI may significantly outperform those who don’t.</i></b>

</p>
 
 


              </div>
              <br />

              
           
<br/>  

<div class="row">
  
<div class="col-md-12"> 
              <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Speakers</h2>          <div class="r_btm"></div>
                      
                 
                      <div className="Our_Speakers container">
                        <center>
                          <div className="Speakers_img" style={{ width: '60%' }}>
                          <div className="row">

{this.Speaker1.map((item, i) => {
 if(i<=12) 
 {
  return (
    <div
      className="main_speaker_card col-md-6 col-sm-12 col-lg-6"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
 }
 else 
 return (
    <div
      className="main_speaker_card col-md-6 col-sm-12 col-lg-6"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
})}
</div>
                          </div>

                        </center>
                      </div>
                 </div>   
                 
        
</div>
<div class="row">
  
<div class="col-md-12"> 
              <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Moderator</h2>          <div class="r_btm"></div>
                      
                 
                      <div className="Our_Speakers container">
                        <center>
                          <div className="Speakers_img" style={{ width: '50%' }}>
                          <div className="row">

{this.Speaker2.map((item, i) => {
 if(i<=12) 
 {
  return (
    <div
      className="main_speaker_card col-md-12 col-sm-12 col-lg-12"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
 }
 else 
 return (
    <div
      className="main_speaker_card col-md-6 col-sm-12 col-lg-6"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
})}
</div>
                          </div>

                        </center>
                      </div>
                 </div>   
                 
        
</div>
            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/IgniteSession16May2026/index.js